module.exports = __webpack_public_path__ + "static/media/Chogath.a0de7979.png";